import { useEffect, useState } from "react";
import { faqs } from "@/mocks/site";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById("faq-jsonld")?.remove();
    };
  }, []);

  return (
    <section id="faq" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="mb-3 flex items-center gap-3">
              <span className="h-2.5 w-2.5 rounded-sm bg-primary-500" />
              <span className="font-en text-xs uppercase tracking-[0.28em] text-primary-600">FAQ</span>
            </div>
            <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[2rem]">
              吃瓜前，先看这些常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于真实性标准、证据链口径与投稿方式的官方解答，帮助你更安心、更理性地吃瓜。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={i}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      aria-expanded={open}
                      className="flex w-full items-start justify-between gap-4 px-5 py-5 text-left md:px-6"
                    >
                      <span className="flex items-start gap-3">
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-xs font-bold text-primary-700">
                          Q
                        </span>
                        <span className="text-[15px] font-semibold text-foreground-900 md:text-base">{f.q}</span>
                      </span>
                      <span
                        className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition ${
                          open
                            ? "rotate-180 border-primary-300 bg-primary-50 text-primary-600"
                            : "border-background-200 text-foreground-400"
                        }`}
                      >
                        <i className="ri-arrow-down-s-line" />
                      </span>
                    </button>
                    {open ? (
                      <div className="px-5 pb-5 md:px-6 md:pl-[62px]">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}